import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import { Box, InputBase, MenuItem, Select, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';

import { IErrorDetail } from '../../../../services/ContentValidator/interfaces/validation.interface';
import AnalysisRow from '../AnalysisRow/AnalysisRow';
import useStyles from './styles';

interface IErrorDetailsProps {
  descriptionMessage: string;
  errorDetails: IErrorDetail[];
}

const ErrorDetails: React.FC<IErrorDetailsProps> = ({
  descriptionMessage,
  errorDetails,
}) => {
  const [filteredErrorDetails, setFilteredErrorDetails] = useState<IErrorDetail[]>([]);
  const [selectedFilter, setSelectedFilter] = useState(errorDetails[0].category);

  useEffect(() => {
    setFilteredErrorDetails(errorDetails);
  }, [errorDetails]);

  useEffect(() => {
    const filtered = errorDetails.filter(error => {
      return error.category === selectedFilter;
    });
    setFilteredErrorDetails(filtered.length ? filtered : errorDetails);
  }, [selectedFilter, errorDetails]);

  const theme: any = useTheme();
  const classes = useStyles();

  const getAllCategories = (): string[] => {
    const errorCategories = new Set(errorDetails.map(error => error.category));
    return Array.from(errorCategories);
  };

  const handleFilterChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    // eslint-disable-next-line no-unused-expressions
    setSelectedFilter?.(event.target.value as string);
  };

  return (
    <>
      <Typography className={classes.description}>{ReactHtmlParser(descriptionMessage)}</Typography>
      {
        getAllCategories().length > 1 && (
          <Box className={classes.selectContainer}>
            <Typography className={classes.selectText}>Show:</Typography>
            <Select
              value={selectedFilter}
              onChange={handleFilterChange}
              input={<InputBase />}
            >
              <MenuItem value="All">
                <em>All</em>
              </MenuItem>
              {getAllCategories().map(category => (
                <MenuItem value={category} key={category}>
                  {category}
                  {' '}
                  only
                </MenuItem>
              ))}
            </Select>
          </Box>
        )
      }
      <Typography variant="h5" className={classes.analysisTitle}>Problems:</Typography>
      {filteredErrorDetails.map(error => (
        <AnalysisRow
          key={error.message}
          error={error}
          iconColor={theme.new.pallette.red.primary}
          extraClassNames={[classes.errorIcon]}
          icon={['far', 'times-circle']}
          category={selectedFilter !== 'All' || getAllCategories().length === 1 ? undefined : error.category}
        />
      ))}
    </>
  );
};

export default ErrorDetails;
